import { useCallback, useState } from 'react';

import environment from '../environment/environment';
import EndOfLevelUrlObject from '../interfaces/end-of-level-url';
import InitializationTestObject from '../interfaces/initialization-test-object';
import ReportsInitializationObject from '../interfaces/reports-initialization-test-object';

const useInitializationObject = () => {
  const [itemsInitializationObject, setItemsInitializationObject] =
    useState<InitializationTestObject>({ loaded: null, loading: false });
  const [reportsInitializationObject, setReportsInitializationObject] =
    useState<ReportsInitializationObject>({ loaded: null, loading: false });

  const getItemsInitializationObject = useCallback((urlParameters: EndOfLevelUrlObject) => {
    if (urlParameters?.contactId && urlParameters?.activityId) {
      setItemsInitializationObject((prevState) => ({ ...prevState, loading: true }));

      const organizationId = urlParameters?.organizationId ?? 'OPEN_ENGLISH_JUNIOR';

      fetch(
        `${environment.REACT_APP_OE_THIRDPARTY_ACTIVITIES_SERVICE_URL}contactId=${urlParameters?.contactId}&organization=${organizationId}&activityId=${urlParameters?.activityId}`,
      )
        .then((serverPromise) => {
          serverPromise
            .json()
            .then(function (data) {
              setItemsInitializationObject({ loaded: true, result: data, loading: false });
            })
            .catch(function () {
              setItemsInitializationObject({ loaded: false, loading: false });
            });
        })
        .catch(function () {
          setItemsInitializationObject({ loaded: false, loading: false });
        });
    } else {
      setItemsInitializationObject({
        loaded: false,
        loading: false,
      });
    }
  }, []);

  const getReportsInitializationObject = useCallback(
    (
      organizationId: string,
      elementId: string,
      type: string,
      contactId: string,
      sessionId: string,
      showCorrectAnswers: boolean,
    ) => {
      setReportsInitializationObject((prevState) => ({ ...prevState, loading: true }));

      fetch(environment.REACT_APP_OE_THIRDPARTY_REPORTS_SERVICE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([
          {
            organizationId,
            id: elementId,
            type,
            user_id: contactId,
            session_id: sessionId,
            questions_api_init_options: {
              showCorrectAnswers,
            },
          },
        ]),
      })
        .then((serverPromise) => {
          serverPromise
            .json()
            .then(function (data) {
              setReportsInitializationObject({ loaded: true, result: data, loading: false });
            })
            .catch(function () {
              setReportsInitializationObject({ loaded: false, loading: false });
            });
        })
        .catch(function () {
          setReportsInitializationObject({ loaded: false, loading: false });
        });
    },
    [],
  );

  return {
    loading: itemsInitializationObject.loading,
    getItemsInitializationObject,
    itemsInitializationObject,
    getReportsInitializationObject,
    reportsInitializationObject,
  };
};

export default useInitializationObject;
